import React, { useState, useEffect, useRef } from 'react';
import {
  Avatar,
  Box,
  Button,
  Card,
  Chip,
  CircularProgress,
  Grid,
  IconButton,
  Skeleton,
  Slide,
  Tooltip,
  Typography,
  useMediaQuery,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { selectCurrentUser, selectCurrentUserEmpCode } from '../../Auth/authSlice';

import NewsCarousel from './NewsCarousel';
import SearchAndFilter from './SearchAndFilter';
import NewsList from './NewsList';
import {
  useGetNewNonTechnicalOpeningsQuery,
  useGetNewOpeningsQuery,
  useGetNewTechnicalOpeningsQuery,
  useGetTopNewsQuery,
  useGetTrendingNewsQuery,
} from '../gnnApiSlice';
import PostNewsDialog from './PostNewsDialog';
import Birthday from './Birthday';
import WorkAnniversary from './WorkAnniversary';
import './FlipCard.css';
import storyImg from './story.png';
import trendingImg from './trendingImg.png';
// import WorkAnniversaryIcon from '../../../assets/Gifs/workAnniversaryIcon.gif';
import CakeIcon from '../../../assets/Gifs/cake.png';
// import NewJoineesIcon from '../../../assets/Gifs/NewJoinees.gif';
import dev from '../../../assets/developers/dev.png';
import SwipeableGrid from './SwipeableGrid.jsx';
import Confetti from 'react-confetti';
import NewsJoinees from './NewJoinees';
import { variants } from '../../../variants/variants';
import CarouselComponent from './carousel';
import { Add, Article, Close, EditNote, Event, Feed, PhotoCamera, Work, WorkHistory } from '@mui/icons-material';
import { useTheme } from '@emotion/react';
import NewsListDesktop from './NewsListDesktop';
import UserAvatar from '../../../common/UserAvatar.jsx';
import { useFetchProfileQuery } from '../../Profile/profileApiSlice.js';
import Stories from './Stories.jsx';
import GnnStories from './GnnStories.jsx';
import { resetPostNews, selectNewsId } from '../gnnSlice.js';
import NewsDetailsNavbar from './NewsDetailsNavbar.jsx';
import NewsComments from './NewsComments.jsx';
import { Outlet, useNavigate } from 'react-router-dom';
import NewOpenings from '../../../assets/Gifs/we-are-hiring.png';
import WorkAnniversaryIcon from '../../../assets/Gifs/workAnniversaryIcon.png';
import NewJoineesIcon from '../../../assets/Gifs/NewJoinees.png';
import NewOpeningsCarousel from './NewOpeningsCarousel.jsx';
import { useFetchBirthdaysQuery, useFetchWorkAnniversaryQuery } from '../../Home/homeApiSlice.js';
import AttachAvatar from '../../../common/AttachAvatar.jsx';
import { object } from 'yup';

const generateRandomGradient = () => {
  const colors = ['blue', 'pink', 'purple', 'red'];
  const color1 = colors[Math.floor(Math.random() * colors.length)];
  const color2 = colors[Math.floor(Math.random() * colors.length)];

  return `linear-gradient(to right, blue, purple, pink);`;
};

const Gnn = () => {
  const theme = useTheme();
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [selectedCountry, setSelectedCountry] = useState('');
  const [selectedRegions, setSelectedRegions] = useState('');
  const dispatch = useDispatch();
  const empCode = useSelector(selectCurrentUserEmpCode);
  const { data: user, isLoading } = useFetchProfileQuery(empCode);

  const [openDialog, setOpenDialog] = useState(false);
  const [newsPosted, setNewsPosted] = useState(false);
  const { data: trendingNews, isLoading: isTrendingLoading, isError: isTrendingError } = useGetTrendingNewsQuery();
  const { data: topNews, isLoading: isTopNewsLoading, isError: isTopError } = useGetTopNewsQuery();
  const {
    data: newOpeningsData,
    isLoading: isNewOpeningsDataLoading,
    isError: isNewOpeningsDataError,
  } = useGetNewOpeningsQuery();
  const {
    data: workAnniversary = [],
    isWorkAnniversaryLoading,
    isWorkAnniversaryError,
  } = useFetchWorkAnniversaryQuery();
  const { data: birthdays = [], isBirthdaysLoading, isBirthdaysError } = useFetchBirthdaysQuery();
  const [isTopCarouselOpen, setTopCarouselOpen] = useState(false);
  const [isTrendingCarouselOpen, setTrendingCarouselOpen] = useState(false);
  const [isBirthdayCarouselOpen, setBirthdayCarouselOpen] = useState(false);
  const [isWorkAnniversariesCarouselOpen, setWorkAnniversariesCarouselOpen] = useState(false);
  const [isNewJoineesCarouselOpen, setNewJoineesCarouselOpen] = useState(false);
  const [isNewOpeningsCarouselOpen, setNewOpeningsCarouselOpen] = useState(false);
  const [isGplCarouselOpen, setGplCarouselOpen] = useState(false);
  const isXs = useMediaQuery(theme.breakpoints.down('xs'));
  const isSm = useMediaQuery(theme.breakpoints.down('sm'));
  const isMd = useMediaQuery(theme.breakpoints.down('md'));
  const isLg = useMediaQuery(theme.breakpoints.down('lg'));
  const isXl = useMediaQuery(theme.breakpoints.up('xl'));
  const isBelow364px = useMediaQuery('(max-width:364px)');
  const navigate = useNavigate();
  const [currentIndex, setCurrentIndex] = useState(-1);
  const [currentIndividualIndex, setCurrentIndividualIndex] = useState(0);
  const [imagesLoaded, setImagesLoaded] = useState({});
  const isAnyCarouselLoading =
    isTopNewsLoading || isTrendingLoading || isNewOpeningsDataLoading || isWorkAnniversaryLoading || isBirthdaysLoading;

  // const [selectedNewsId, setSelectedNewsId] = useState(null);
  const selectedNewsId = useSelector(selectNewsId);
  useEffect(() => {
    if (!isSm && selectedNewsId) {
      navigate(`/home/announcement/gnn/${selectedNewsId}`);
    }
  }, [selectedNewsId]);

  const sentMessageToNative = () => {
    window['ReactNativeWebView'] &&
      window['ReactNativeWebView']?.postMessage(JSON.stringify({ type: 'storyOpened', value: true }));
  };

  useEffect(() => {
    function handleStoryClose(event) {
      const message = event.data;
      if (message.type === 'closeStory') {
        setTopCarouselOpen(false);
        setTrendingCarouselOpen(false);
        setBirthdayCarouselOpen(false);
        setWorkAnniversariesCarouselOpen(false);
        setNewJoineesCarouselOpen(false);
        setNewOpeningsCarouselOpen(false);
        setGplCarouselOpen(false);
        console.log('into the closeStory');
      }
    }
    window.addEventListener('message', handleStoryClose);
  }, []);

  const handleCloseCarousel = () => {
    setTopCarouselOpen(false);
    setTrendingCarouselOpen(false);
    setBirthdayCarouselOpen(false);
    setWorkAnniversariesCarouselOpen(false);
    setNewJoineesCarouselOpen(false);
    setNewOpeningsCarouselOpen(false);
    setGplCarouselOpen(false);
    // console.log('into the handleCloseCarousel');
  };
  const handleOpenTopCarousel = () => {
    setTopCarouselOpen(true);
    sentMessageToNative();
  };

  const handleCloseTopCarousel = () => {
    setTopCarouselOpen(false);
  };

  const handleOpenBirthdayCarousel = () => {
    setBirthdayCarouselOpen(true);
    sentMessageToNative();
  };

  const handleCloseBirthdayCarousel = () => {
    setBirthdayCarouselOpen(false);
  };

  const handleOpenWorkAnniversariesCarousel = () => {
    setWorkAnniversariesCarouselOpen(true);
    sentMessageToNative();
  };

  const handleCloseWorkAnniversariesCarousel = () => {
    setWorkAnniversariesCarouselOpen(false);
  };

  const handleOpenNewJoineesCarousel = () => {
    setNewJoineesCarouselOpen(true);
    sentMessageToNative();
  };

  const handleCloseNewJoineesCarousel = () => {
    setNewJoineesCarouselOpen(false);
  };
  const handleOpenNewOpeningsCarousel = () => {
    setNewOpeningsCarouselOpen(true);
    sentMessageToNative();
  };

  const handleCloseNewOpeningsCarousel = () => {
    setNewOpeningsCarouselOpen(false);
  };

  const handleOpenGplCarousel = () => {
    setGplCarouselOpen(true);
    sentMessageToNative();
  };

  const handleCloseGplCarousel = () => {
    setGplCarouselOpen(false);
  };

  const handleOpenTrendingCarousel = () => {
    setTrendingCarouselOpen(true);
    sentMessageToNative();
  };

  const handleCloseTrendingCarousel = () => {
    setTrendingCarouselOpen(false);
  };

  const handleCategoryChange = (event) => {
    setSelectedCategory(event.target.value);
  };

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };
  const handleOpenDialog = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    dispatch(resetPostNews());
  };

  const handlePostNews = (formData) => {
    // console.log('Posting news:', formData);
    setOpenDialog(false);
  };

  const handleCountryChange = (event, newValue) => {
    setSelectedCountry(newValue);
    setSelectedRegions('');
  };
  // console.log(selectedCountry, 'selectedCountry');

  const handleRegionChange = (event, newValue) => {
    setSelectedRegions(newValue);
  };

  const carousels = [
    {
      name: 'Featured',
      icon: (
        <Avatar
          src={storyImg}
          sx={{
            height: { xs: '35px', sm: '35px', md: '50px' },
            width: { xs: '35px', sm: '35px', md: '50px' },
          }}
        />
      ),
      open: isTopCarouselOpen,
      onOpen: handleOpenTopCarousel,
      onClose: handleCloseTopCarousel,
      content: (
        <NewsCarousel
          isSm={isSm}
          topNews={topNews}
          isLoading={isTopNewsLoading}
          isError={isTopError}
          isTopNews={true}
          currentIndex={currentIndividualIndex}
          setCurrentIndex={setCurrentIndividualIndex}
          handleCloseCarousel={handleCloseCarousel}
        />
      ),
    },
    {
      name: 'Trending',
      icon: (
        <Avatar
          src={trendingImg}
          sx={{
            height: { xs: '35px', sm: '35px', md: '50px' },
            width: { xs: '35px', sm: '35px', md: '50px' },
            border: '1px solid grey',
          }}
        />
      ),
      open: isTrendingCarouselOpen,
      onOpen: handleOpenTrendingCarousel,
      onClose: handleCloseTrendingCarousel,
      content: (
        <NewsCarousel
          isSm={isSm}
          topNews={trendingNews}
          isLoading={isTrendingLoading}
          isError={isTrendingError}
          currentIndex={currentIndividualIndex}
          setCurrentIndex={setCurrentIndividualIndex}
          handleCloseCarousel={handleCloseCarousel}
        />
      ),
    },
    {
      name: 'Birthdays',
      icon: (
        <Avatar
          src={CakeIcon}
          sx={{
            height: { xs: '35px', sm: '35px', md: '50px' },
            width: { xs: '35px', sm: '35px', md: '50px' },
          }}
        />
      ),
      open: isBirthdayCarouselOpen,
      onOpen: handleOpenBirthdayCarousel,
      onClose: handleCloseBirthdayCarousel,
      content: <Birthday />,
    },
    {
      name: 'Anniversaries',
      icon: (
        <Avatar
          src={WorkAnniversaryIcon}
          sx={{
            height: { xs: '35px', sm: '35px', md: '50px' },
            width: { xs: '35px', sm: '35px', md: '50px' },
          }}
        />
      ),
      open: isWorkAnniversariesCarouselOpen,
      onOpen: handleOpenWorkAnniversariesCarousel,
      onClose: handleCloseWorkAnniversariesCarousel,
      content: <WorkAnniversary />,
    },
    {
      name: 'Joinees',
      icon: (
        <Avatar
          src={NewJoineesIcon}
          sx={{
            height: { xs: '35px', sm: '35px', md: '50px' },
            width: { xs: '35px', sm: '35px', md: '50px' },
          }}
        />
      ),
      open: isNewJoineesCarouselOpen,
      onOpen: handleOpenNewJoineesCarousel,
      onClose: handleCloseNewJoineesCarousel,
      content: <NewsJoinees />,
    },
    {
      name: 'Twinwin',
      icon: (
        <Avatar
          src={NewOpenings}
          sx={{
            height: { xs: '35px', sm: '35px', md: '50px' },
            width: { xs: '35px', sm: '35px', md: '50px' },
          }}
        />
      ),
      open: isNewOpeningsCarouselOpen,
      onOpen: handleOpenNewOpeningsCarousel,
      onClose: handleCloseNewOpeningsCarousel,
      content: (
        <NewOpeningsCarousel
          isSm={isSm}
          newOpenings={newOpeningsData}
          currentIndex={currentIndividualIndex}
          setCurrentIndex={setCurrentIndividualIndex}
          isLoading={isNewOpeningsDataLoading}
          isError={isNewOpeningsDataError}
          handleCloseCarousel={handleCloseCarousel}
        />
      ),
    },
  ];

  const handleSwipeRight = () => {
    setCurrentIndex((prevIndex) => Math.min(prevIndex + 1, carousels.length - 1));
  };

  const handleSwipeLeft = () => {
    setCurrentIndex((prevIndex) => Math.max(prevIndex - 1, 0));
  };

  const handleSwipeUp = () => {
    carousels[currentIndex].onClose();
    setCurrentIndex(-1);
  };
  // console.log(selectedRegions, 'selectedRegion');
  useEffect(() => {
    // Handle messages from React Native
    const handleMessage = (event) => {
      if (event.data === 'closeDialog' && openDialog) {
        handleCloseDialog();
      }
    };

    window.addEventListener('message', handleMessage);

    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, [openDialog, handleCloseDialog]);
  if (isTrendingError) {
    return <p>Error: Failed to fetch news</p>;
  }
  const gradientKeyframes = `
  @keyframes gradientAnimation {
    0% { background-position: 0% 50%; }
    50% { background-position: 60% 50%; }
    100% { background-position: 0% 50%; }
  }
`;

  const chipsStyle = {
    position: 'absolute',
    // top: 5,
    // zIndex: 2,
    background: generateRandomGradient(),
    backgroundSize: '200% 200%',
    animation: 'gradientAnimation 4s ease infinite',
    borderRadius: '0 16px 16px 0',
  };
  // console.log('selectedNewsId', selectedNewsId)
  return isSm ? (
    <Grid
      container
      sx={{
        backgroundColor: '#F4F2EE',
        padding: 0,
        // padding: 1,
        height: 'auto',
        overflow: 'hidden',
        // borderRadius: variants.boxRadius.NAVBAR,
        // border: 1,
        borderColor: 'divider',
      }}
    >
      {/* <Grid xs={12} md={12} xl={12} lg={12} sx={{}}>
        <Grid item sx={{ overflow: 'auto' }}> */}
      <PostNewsDialog
        open={openDialog}
        onClose={handleCloseDialog}
        onSubmit={handlePostNews}
        newsPosted={newsPosted}
        setNewsPosted={setNewsPosted}
      />

      {/* <Grid sx={{}}> */}
      <NewsList
        setNewsPosted={setNewsPosted}
        newsPosted={newsPosted}
        selectedCategory={selectedCategory}
        searchTerm={searchTerm}
        selectedCountry={selectedCountry}
        selectedRegions={selectedRegions}
      >
        <div style={{ width: '100%', height: 'auto' }}>
          <Grid
            sx={{
              backgroundColor: 'white',
              overflowX: 'auto', // Make sure overflowX is always 'auto' for consistent scrolling
              width: '100%', // Set the width to 100% to prevent the grid from expanding beyond its container
              display: 'flex', // Flexbox for better alignment and handling of child components
              flexWrap: 'nowrap', // Prevents wrapping of content which can cause the need for double scroll
            }}
          >
            <GnnStories
              isSm={isSm}
              isTopCarouselOpen={isTopCarouselOpen}
              handleOpenTopCarousel={handleOpenTopCarousel}
              handleCloseTopCarousel={handleCloseTopCarousel}
              topNews={topNews}
              isTopNewsLoading={isTopNewsLoading}
              isTopError={isTopError}
              isTrendingCarouselOpen={isTrendingCarouselOpen}
              handleOpenTrendingCarousel={handleOpenTrendingCarousel}
              handleCloseTrendingCarousel={handleCloseTrendingCarousel}
              trendingNews={trendingNews}
              isTrendingLoading={isTrendingLoading}
              isTrendingError={isTrendingError}
              isBirthdayCarouselOpen={isBirthdayCarouselOpen}
              handleOpenBirthdayCarousel={handleOpenBirthdayCarousel}
              handleCloseBirthdayCarousel={handleCloseBirthdayCarousel}
              isWorkAnniversariesCarouselOpen={isWorkAnniversariesCarouselOpen}
              handleOpenWorkAnniversariesCarousel={handleOpenWorkAnniversariesCarousel}
              handleCloseWorkAnniversariesCarousel={handleCloseWorkAnniversariesCarousel}
              isNewJoineesCarouselOpen={isNewJoineesCarouselOpen}
              handleOpenNewJoineesCarousel={handleOpenNewJoineesCarousel}
              handleCloseNewJoineesCarousel={handleCloseNewJoineesCarousel}
              newOpenings={newOpeningsData}
              isNewOpeningsDataLoading={isNewOpeningsDataLoading}
              isNewOpeningsDataError={isNewOpeningsDataError}
              isNewOpeningsCarouselOpen={isNewOpeningsCarouselOpen}
              handleOpenNewOpeningsCarousel={handleOpenNewOpeningsCarousel}
              handleCloseNewOpeningsCarousel={handleCloseNewOpeningsCarousel}
              setNewOpeningsCarouselOpen={setNewOpeningsCarouselOpen}
              isGplCarouselOpen={isGplCarouselOpen}
              handleOpenGplCarousel={handleOpenGplCarousel}
              handleCloseGplCarousel={handleCloseGplCarousel}
            />
          </Grid>
          {/* <Stories /> */}

          <Box
            display="flex"
            flexDirection="column"
            // alignItems="center"
            p={1}
            bgcolor="white"
            // #f3f2ef
            // borderRadius={2}
            // boxShadow={1}
            sx={{
              mt: 1,
              // mb: 1,
              border: 1, // applies a general border to see the corner styles
              borderColor: 'divider',
              borderLeft: 'none', // remove left border to highlight bottom left radius
              borderRight: 'none', // remove right border to show the effect clearly
            }}
          >
            <Grid sx={{ mt: 1, display: 'flex', flexDirection: 'row' }}>
              {/* <Avatar src={user && user?.employeePhotoPath} alt="Profile" /> */}
              <Avatar
                empCode={empCode}
                showStatus={true}
                src={user && user?.employeePhotoPath}
                size={35}
                sx={{ img: { objectFit: 'cover', objectPosition: 'top' } }}
              />
              <Box
                ml={2}
                flexGrow={1}
                onClick={handleOpenDialog}
                sx={{
                  textTransform: 'none',
                  justifyContent: 'flex-start',
                  width: '100%',
                  borderRadius: 30,
                  paddingLeft: 2,
                  paddingTop: 1,
                  paddingBottom: 1,
                  border: 1,
                  borderColor: 'darkgrey',
                  borderRadius: '20px',
                }}
              >
                <Tooltip title="Post News">
                  <Typography color="textSecondary" sx={{ fontSize: '12px', mt: 0.2 }}>
                    Start a post, try writing GNews
                  </Typography>
                </Tooltip>
                {/* </Button> */}
              </Box>
            </Grid>

            <Box display="flex" sx={{ mt: 1, justifyContent: 'space-between', gap: '1rem' }}>
              <IconButton onClick={handleOpenDialog}>
                <PhotoCamera sx={{ color: 'grey', mr: 1 }} />
                <Typography variant="body2" sx={{ color: 'grey' }}>
                  Media
                </Typography>
              </IconButton>
              <IconButton onClick={handleOpenDialog}>
                <EditNote sx={{ color: 'grey', mr: 1 }} />
                <Typography variant="body2" sx={{ color: 'grey' }}>
                  Write Article
                </Typography>
              </IconButton>
              <IconButton onClick={handleOpenDialog}>
                <Feed sx={{ color: 'grey', mr: 1 }} />
                <Typography variant="body2" sx={{ color: 'grey' }}>
                  News
                </Typography>
              </IconButton>
            </Box>
          </Box>

          <SearchAndFilter
            searchTerm={searchTerm}
            onSearchChange={handleSearchChange}
            selectedCategory={selectedCategory}
            onCategoryChange={handleCategoryChange}
            selectedCountry={selectedCountry}
            selectedRegions={selectedRegions}
            handleCountryChange={handleCountryChange}
            handleRegionChange={handleRegionChange}
          />
        </div>
      </NewsList>
      {/* </Grid> */}
      {/* </Grid>
      </Grid> */}
    </Grid>
  ) : (
    <Grid
      container
      sx={{
        // backgroundColor: 'white',
        // padding: 1,
        height: '90vh',
        overflow: 'hidden',
        // borderRadius: variants.boxRadius.NAVBAR,
        // border: 1,
        borderColor: 'divider',
      }}
    >
      <Grid xs={12} md={12} xl={12} lg={12} sx={{ height: '100%', p: 1 }} item>
        <Grid item sx={{ height: '100%' }}>
          <Grid sx={{ overflowX: isSm ? 'auto' : '', width: 'auto', scrollBehavior: 'smooth' }}>
            {selectedCategory != '0' ? (
              isTopCarouselOpen ? (
                <Grid sx={{ backgroundColor: 'transparent', height: '90vh' }}>
                  <IconButton
                    onClick={handleCloseCarousel}
                    style={{ position: 'absolute', top: 20, right: 20, zIndex: '10001' }}
                  >
                    <Close />
                  </IconButton>
                  <Box
                    id="dialog-container"
                    sx={{
                      width: '500px',
                      height: '800px',
                      // border: '1px solid red',
                      margin: '0 auto',
                      position: 'relative',
                      overflow: 'hidden',
                    }}
                  >
                    <SwipeableGrid
                      key={1}
                      isSm={isSm}
                      handleSwipeLeft={handleSwipeLeft}
                      handleSwipeRight={handleSwipeRight}
                      topNews={topNews}
                      trendingNews={trendingNews}
                      storyLength={carousels[0].name === 'Featured' ? topNews?.length - 1 : trendingNews?.length - 1}
                      handleSwipeUp={() => {
                        carousels[0].onClose();
                        setCurrentIndex(-1);
                      }}
                      // handleSwipeDown={handleSwipeDown}
                      // handleSwipeDown={() => handleSwipeDown(newsItems[currentIndividualIndex].id)}
                      carouselName={carousels[0].name}
                      carouselIcon={carousels[0].icon}
                      currentIndex={currentIndividualIndex}
                      setCurrentIndex={setCurrentIndividualIndex}
                      iterableData={
                        carousels[0].name === 'Featured'
                          ? topNews
                          : carousels[0].name === 'Trending'
                          ? trendingNews
                          : newOpeningsData
                      }
                      isLoading={
                        carousels[0].name === 'Featured'
                          ? isTopNewsLoading
                          : carousels[0].name === 'Trending'
                          ? isTrendingLoading
                          : isNewOpeningsDataLoading
                      }
                    >
                      {carousels[0].content}
                    </SwipeableGrid>
                  </Box>
                </Grid>
              ) : isTrendingCarouselOpen ? (
                <Grid sx={{ backgroundColor: 'transparent', height: '90vh' }}>
                  <IconButton
                    onClick={handleCloseCarousel}
                    style={{ position: 'absolute', top: 20, right: 20, zIndex: '10001' }}
                  >
                    <Close />
                  </IconButton>
                  <Box
                    id="dialog-container"
                    sx={{
                      width: '500px',
                      height: '800px',
                      // border: '1px solid red',
                      margin: '0 auto',
                      position: 'relative',
                      overflow: 'hidden',
                    }}
                  >
                    <SwipeableGrid
                      key={1}
                      isSm={isSm}
                      handleSwipeLeft={handleSwipeLeft}
                      handleSwipeRight={handleSwipeRight}
                      topNews={topNews}
                      trendingNews={trendingNews}
                      storyLength={carousels[1].name === 'Featured' ? topNews?.length - 1 : trendingNews?.length - 1}
                      handleSwipeUp={() => {
                        carousels[1].onClose();
                        setCurrentIndex(-1);
                      }}
                      // handleSwipeDown={handleSwipeDown}
                      // handleSwipeDown={() => handleSwipeDown(newsItems[currentIndividualIndex].id)}
                      carouselName={carousels[1].name}
                      carouselIcon={carousels[1].icon}
                      currentIndex={currentIndividualIndex}
                      setCurrentIndex={setCurrentIndividualIndex}
                      iterableData={
                        carousels[1].name === 'Featured'
                          ? topNews
                          : carousels[1].name === 'Trending'
                          ? trendingNews
                          : newOpeningsData
                      }
                      isLoading={
                        carousels[1].name === 'Featured'
                          ? isTopNewsLoading
                          : carousels[1].name === 'Trending'
                          ? isTrendingLoading
                          : isNewOpeningsDataLoading
                      }
                    >
                      {carousels[1].content}
                    </SwipeableGrid>
                  </Box>
                </Grid>
              ) : isNewOpeningsCarouselOpen ? (
                <Grid sx={{ backgroundColor: 'transparent', height: '90vh' }}>
                  <IconButton
                    onClick={handleCloseCarousel}
                    style={{ position: 'absolute', top: 20, right: 20, zIndex: '10001' }}
                  >
                    <Close />
                  </IconButton>
                  <Box
                    id="dialog-container"
                    sx={{
                      width: '500px',
                      height: '800px',
                      // border: '1px solid red',
                      margin: '0 auto',
                      position: 'relative',
                      overflow: 'hidden',
                    }}
                  >
                    <SwipeableGrid
                      key={1}
                      isSm={isSm}
                      handleSwipeLeft={handleSwipeLeft}
                      handleSwipeRight={handleSwipeRight}
                      topNews={topNews}
                      trendingNews={trendingNews}
                      storyLength={carousels[5].name === 'Featured' ? topNews?.length - 1 : trendingNews?.length - 1}
                      handleSwipeUp={() => {
                        carousels[5].onClose();
                        setCurrentIndex(-1);
                      }}
                      carouselName={carousels[5].name}
                      carouselIcon={carousels[5].icon}
                      currentIndex={currentIndividualIndex}
                      setCurrentIndex={setCurrentIndividualIndex}
                      iterableData={
                        carousels[5].name === 'Featured'
                          ? topNews
                          : carousels[5].name === 'Trending'
                          ? trendingNews
                          : newOpeningsData
                      }
                      isLoading={
                        carousels[5].name === 'Featured'
                          ? isTopNewsLoading
                          : carousels[5].name === 'Trending'
                          ? isTrendingLoading
                          : isNewOpeningsDataLoading
                      }
                    >
                      {carousels[5].content}
                    </SwipeableGrid>
                  </Box>
                </Grid>
              ) : isBirthdayCarouselOpen ? (
                <Grid sx={{ backgroundColor: 'transparent', height: '90vh' }}>
                  <IconButton
                    onClick={handleCloseCarousel}
                    style={{ position: 'absolute', top: 20, right: 20, zIndex: '10001' }}
                  >
                    <Close />
                  </IconButton>
                  <Box
                    id="dialog-container"
                    sx={{
                      width: '500px',
                      height: '800px',
                      // border: '1px solid red',
                      margin: '0 auto',
                      position: 'relative',
                      overflow: 'hidden',
                    }}
                  >
                    <SwipeableGrid
                      key={1}
                      isSm={isSm}
                      handleSwipeLeft={handleSwipeLeft}
                      handleSwipeRight={handleSwipeRight}
                      topNews={topNews}
                      trendingNews={trendingNews}
                      storyLength={carousels[2].name === 'Featured' ? topNews?.length - 1 : trendingNews?.length - 1}
                      handleSwipeUp={() => {
                        carousels[2].onClose();
                        setCurrentIndex(-1);
                      }}
                      // handleSwipeDown={handleSwipeDown}
                      // handleSwipeDown={() => handleSwipeDown(newsItems[currentIndividualIndex].id)}
                      carouselName={carousels[2].name}
                      carouselIcon={carousels[2].icon}
                      currentIndex={currentIndividualIndex}
                      setCurrentIndex={setCurrentIndividualIndex}
                      iterableData={
                        carousels[2].name === 'Featured'
                          ? topNews
                          : carousels[2].name === 'Trending'
                          ? trendingNews
                          : newOpeningsData
                      }
                      isLoading={
                        carousels[2].name === 'Featured'
                          ? isTopNewsLoading
                          : carousels[2].name === 'Trending'
                          ? isTrendingLoading
                          : isNewOpeningsDataLoading
                      }
                    >
                      {carousels[2].content}
                    </SwipeableGrid>
                  </Box>
                </Grid>
              ) : isWorkAnniversariesCarouselOpen ? (
                <Grid sx={{ backgroundColor: 'transparent', height: '90vh' }}>
                  <IconButton
                    onClick={handleCloseCarousel}
                    style={{ position: 'absolute', top: 20, right: 20, zIndex: '10001' }}
                  >
                    <Close />
                  </IconButton>
                  <Box
                    id="dialog-container"
                    sx={{
                      width: '500px',
                      height: '800px',
                      // border: '1px solid red',
                      margin: '0 auto',
                      position: 'relative',
                      overflow: 'hidden',
                    }}
                  >
                    <SwipeableGrid
                      key={1}
                      isSm={isSm}
                      handleSwipeLeft={handleSwipeLeft}
                      handleSwipeRight={handleSwipeRight}
                      topNews={topNews}
                      trendingNews={trendingNews}
                      storyLength={carousels[3].name === 'Featured' ? topNews?.length - 1 : trendingNews?.length - 1}
                      handleSwipeUp={() => {
                        carousels[3].onClose();
                        setCurrentIndex(-1);
                      }}
                      // handleSwipeDown={handleSwipeDown}
                      // handleSwipeDown={() => handleSwipeDown(newsItems[currentIndividualIndex].id)}
                      carouselName={carousels[3].name}
                      carouselIcon={carousels[3].icon}
                      currentIndex={currentIndividualIndex}
                      setCurrentIndex={setCurrentIndividualIndex}
                      iterableData={
                        carousels[3].name === 'Featured'
                          ? topNews
                          : carousels[3].name === 'Trending'
                          ? trendingNews
                          : newOpeningsData
                      }
                      isLoading={
                        carousels[3].name === 'Featured'
                          ? isTopNewsLoading
                          : carousels[3].name === 'Trending'
                          ? isTrendingLoading
                          : isNewOpeningsDataLoading
                      }
                    >
                      {carousels[3].content}
                    </SwipeableGrid>
                  </Box>
                </Grid>
              ) : isNewJoineesCarouselOpen ? (
                <Grid sx={{ backgroundColor: 'transparent', height: '90vh' }}>
                  <IconButton
                    onClick={handleCloseCarousel}
                    style={{ position: 'absolute', top: 20, right: 20, zIndex: '10001' }}
                  >
                    <Close />
                  </IconButton>
                  <Box
                    id="dialog-container"
                    sx={{
                      width: '500px',
                      height: '800px',
                      // border: '1px solid red',
                      margin: '0 auto',
                      position: 'relative',
                      overflow: 'hidden',
                    }}
                  >
                    <SwipeableGrid
                      key={1}
                      isSm={isSm}
                      handleSwipeLeft={handleSwipeLeft}
                      handleSwipeRight={handleSwipeRight}
                      topNews={topNews}
                      trendingNews={trendingNews}
                      storyLength={carousels[4].name === 'Featured' ? topNews?.length - 1 : trendingNews?.length - 1}
                      handleSwipeUp={() => {
                        carousels[4].onClose();
                        setCurrentIndex(-1);
                      }}
                      // handleSwipeDown={handleSwipeDown}
                      // handleSwipeDown={() => handleSwipeDown(newsItems[currentIndividualIndex].id)}
                      carouselName={carousels[4].name}
                      carouselIcon={carousels[4].icon}
                      currentIndex={currentIndividualIndex}
                      setCurrentIndex={setCurrentIndividualIndex}
                      iterableData={
                        carousels[4].name === 'Featured'
                          ? topNews
                          : carousels[4].name === 'Trending'
                          ? trendingNews
                          : newOpeningsData
                      }
                      isLoading={
                        carousels[4].name === 'Featured'
                          ? isTopNewsLoading
                          : carousels[4].name === 'Trending'
                          ? isTrendingLoading
                          : isNewOpeningsDataLoading
                      }
                    >
                      {carousels[4].content}
                    </SwipeableGrid>
                  </Box>
                </Grid>
              ) : isAnyCarouselLoading ? (
                <Grid
                  container
                  gap={2}
                  sx={{
                    width: '100vw',
                    overflowX: 'auto', // Enable horizontal scrolling
                    flexDirection: 'row', // Arrange items horizontally
                    flexWrap: 'nowrap',
                  }}
                >
                  {carousels.map((carousel, index) => (
                    <Grid
                      item
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        cursor: 'default',
                      }}
                    >
                      <Skeleton
                        variant="circular"
                        sx={{
                          bgcolor: 'grey.300',
                          height: { xs: '60px', sm: '80px', md: '60px' },
                          width: { xs: '60px', sm: '80px', md: '60px' },
                        }}
                      />
                      <Skeleton
                        variant="text"
                        sx={{
                          mt: 1,
                          width: { xs: '40px', sm: '60px', md: '70px' },
                          fontSize: { xs: '0.5rem', sm: '0.8rem', md: '0.9rem' },
                        }}
                      />
                    </Grid>
                  ))}
                </Grid>
              ) : (
                // <Grid container spacing={1} paddingRight={2.3} paddingLeft={0.8} paddingBottom={0} marginBottom={0}>
                <Grid
                  container
                  gap={2}
                  sx={{
                    width: '100vw',
                    overflowX: 'auto', // Enable horizontal scrolling
                    flexDirection: 'row', // Arrange items horizontally
                    flexWrap: 'nowrap',
                  }}
                >
                  <Grid
                    item
                    onClick={handleOpenTopCarousel}
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      cursor: 'default',
                      '&:hover': {
                        opacity: 0.8,
                      },
                    }}
                  >
                    <Avatar
                      src={storyImg}
                      sx={{
                        height: { xs: '60px', sm: '80px', md: '60px' },
                        width: { xs: '60px', sm: '80px', md: '60px' },
                        border: '2px dotted purple',
                      }}
                    />
                    <Typography
                      sx={{
                        mt: 1,
                        fontSize: { xs: '0.5rem', sm: '0.8rem', md: '0.9rem' },
                        textAlign: 'center',
                      }}
                    >
                      Featured
                    </Typography>
                  </Grid>

                  {
                    <Grid
                      item
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        cursor: 'default',
                        '&:hover': {
                          opacity: 0.8,
                        },
                      }}
                      onClick={handleOpenTrendingCarousel}
                    >
                      <Avatar
                        src={trendingImg}
                        sx={{
                          backgroundColor: 'white',
                          height: { xs: '60px', sm: '80px', md: '60px' },
                          width: { xs: '60px', sm: '80px', md: '60px' },
                          border: '2px dotted purple',
                        }}
                      />
                      <Typography
                        sx={{
                          mt: 1,
                          fontSize: { xs: '0.5rem', sm: '0.8rem', md: '0.9rem' },
                          textAlign: 'center',
                        }}
                      >
                        Trending
                      </Typography>
                    </Grid>
                  }
                  {
                    <Grid
                      item
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        cursor: 'default',
                        '&:hover': {
                          opacity: 0.8,
                        },
                      }}
                      onClick={handleOpenNewOpeningsCarousel}
                    >
                      <Avatar
                        src={NewOpenings}
                        sx={{
                          backgroundColor: 'white',
                          height: { xs: '60px', sm: '80px', md: '60px' },
                          width: { xs: '60px', sm: '80px', md: '60px' },
                          border: '2px dotted purple',
                        }}
                      />
                      <Typography
                        sx={{
                          mt: 1,
                          fontSize: { xs: '0.5rem', sm: '0.8rem', md: '0.9rem' },
                          textAlign: 'center',
                        }}
                      >
                        Twinwin
                      </Typography>
                    </Grid>
                  }

                  {
                    <Grid
                      item
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        cursor: 'default',
                        '&:hover': {
                          opacity: 0.8,
                        },
                      }}
                      onClick={handleOpenBirthdayCarousel}
                    >
                      <Avatar
                        src={CakeIcon}
                        sx={{
                          backgroundColor: 'white',
                          height: { xs: '60px', sm: '80px', md: '60px' },
                          width: { xs: '60px', sm: '80px', md: '60px' },
                          border: '2px dotted purple',
                        }}
                      />
                      <Typography
                        sx={{
                          mt: 1,
                          fontSize: { xs: '0.5rem', sm: '0.8rem', md: '0.9rem' },
                          textAlign: 'center',
                        }}
                      >
                        Birthdays
                      </Typography>
                    </Grid>
                  }

                  {
                    <Grid
                      item
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        cursor: 'default',
                        '&:hover': {
                          opacity: 0.8,
                        },
                      }}
                      onClick={handleOpenWorkAnniversariesCarousel}
                    >
                      <Avatar
                        src={WorkAnniversaryIcon}
                        sx={{
                          backgroundColor: 'white',
                          height: { xs: '60px', sm: '80px', md: '60px' },
                          width: { xs: '60px', sm: '80px', md: '60px' },
                          border: '2px dotted purple',
                        }}
                      />
                      <Typography
                        sx={{
                          mt: 1,
                          fontSize: { xs: '0.5rem', sm: '0.8rem', md: '0.9rem' },
                          textAlign: 'center',
                        }}
                      >
                        Anniversaries
                      </Typography>
                    </Grid>
                  }

                  {
                    <Grid
                      item
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        cursor: 'default',
                        '&:hover': {
                          opacity: 0.8,
                        },
                      }}
                      onClick={handleOpenNewJoineesCarousel}
                    >
                      <Avatar
                        src={NewJoineesIcon}
                        sx={{
                          backgroundColor: 'white',
                          height: { xs: '60px', sm: '80px', md: '60px' },
                          width: { xs: '60px', sm: '80px', md: '60px' },
                          border: '2px dotted purple',
                        }}
                      />
                      <Typography
                        sx={{
                          mt: 1,
                          fontSize: { xs: '0.5rem', sm: '0.8rem', md: '0.9rem' },
                          textAlign: 'center',
                        }}
                      >
                        Joinees
                      </Typography>
                    </Grid>
                  }
                </Grid>
              )
            ) : (
              <></>
            )}
          </Grid>

          {/* <Stories /> */}
          <Grid
            item
            xs={12}
            lg={12}
            container
            sx={{
              // flex: 1,
              p: 1,
              pl: 0,
              display: 'grid',
              gridTemplateRows: '70px 1fr',
              height: `calc(100vh - 200px)`, // Adjust height to fill the remaining space
              // height: '89%',
              width: '100%',
              [theme.breakpoints.down('lg')]: {
                display: 'grid',
                p: 0,
              },
            }}
          >
            <Outlet />
            {/* <NewsDetailsNavbar handleNavigate={handleCloseDialog} /> */}
            {/* {selectedNewsId ? <NewsComments id={"6853f8c7571513b32640c661"} /> : <></>} */}
            {/* <NewsComments id={'6853f8c7571513b32640c661'} /> */}
          </Grid>
          {/* <Grid
            item
            xs={12}
            md={12}
            sx={{
              ml: !isSm ? '1rem' : '',
              mr: !isSm ? '1rem' : '',
              // marginBottom: '2rem',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              // width: '96%',
            }}
          > */}
          {/* <SearchAndFilter
              searchTerm={searchTerm}
              onSearchChange={handleSearchChange}
              selectedCategory={selectedCategory}
              onCategoryChange={handleCategoryChange}
              selectedCountry={selectedCountry}
              selectedRegions={selectedRegions}
              handleCountryChange={handleCountryChange}
              handleRegionChange={handleRegionChange}
            />
            <Tooltip title="Post News">
              <IconButton size="large" onClick={handleOpenDialog} sx={{}}>
                +
              </IconButton>
            </Tooltip> */}
          {/* </Grid> */}

          {/* <PostNewsDialog
            open={openDialog}
            onClose={handleCloseDialog}
            onSubmit={handlePostNews}
            newsPosted={newsPosted}
            setNewsPosted={setNewsPosted}
            setOpenDialog={setOpenDialog}
          /> */}

          {/* <Grid sx={{}}>
            <NewsListDesktop
              setNewsPosted={setNewsPosted}
              newsPosted={newsPosted}
              selectedCategory={selectedCategory}
              searchTerm={searchTerm}
              selectedCountry={selectedCountry}
              selectedRegions={selectedRegions}
            />
          </Grid> */}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Gnn;
